// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Inter:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   ZUPPA LMS FOOTER - Full Responsive CSS
   All classNames prefixed: zuppa_lms_foot_pg_
   ============================================ */

/* ---- Root Footer ---- */
.zuppa_lms_foot_pg_footer {
  width: 100%;
  background: linear-gradient(135deg, #0a0f1e 0%, #0d1b2a 50%, #0a1628 100%);
  font-family: 'Inter', sans-serif;
  position: relative;
  overflow: hidden;
}

/* ---- Canvas Background ---- */
.zuppa_lms_foot_pg_canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0.15;
  z-index: 0;
}

/* ---- Outer Wrapper ---- */
.zuppa_lms_foot_pg_wrapper {
  position: relative;
  z-index: 1;
  border-top: 2px solid rgb(255, 123, 0);
  padding: 60px 5% 40px;
}

/* ---- Inner Grid Container ---- */
.zuppa_lms_foot_pg_container {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr auto;
  gap: 40px;
  align-items: start;
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
}

/* ============================================
   BRAND SECTION (Left)
   ============================================ */
.zuppa_lms_foot_pg_brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.zuppa_lms_foot_pg_logo {
  width: 80px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgba(0, 180, 255, 0.4));
  transition: filter 0.3s ease;
}

.zuppa_lms_foot_pg_logo:hover {
  filter: drop-shadow(0 0 18px rgba(0, 220, 255, 0.7));
}

.zuppa_lms_foot_pg_brand_name {
  font-family: 'Rajdhani', sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: #e0f4ff;
  letter-spacing: 0.04em;
  margin: 0;
  line-height: 1.3;
  text-transform: uppercase;
}

.zuppa_lms_foot_pg_brand_sub {
  font-size: 0.78rem;
  color: #ff9900;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 0;
  font-weight: 500;
}

/* ============================================
   SOCIAL SECTION (Center)
   ============================================ */
.zuppa_lms_foot_pg_social {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
}

.zuppa_lms_foot_pg_social_title {
  font-family: 'Rajdhani', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #ff7300;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin: 0;
  position: relative;
  padding-bottom: 8px;
}

.zuppa_lms_foot_pg_social_title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 36px;
  height: 2px;
  background: linear-gradient(90deg, #ff7300, transparent);
  border-radius: 2px;
}

.zuppa_lms_foot_pg_social_icons {
  display: flex;
  flex-direction: row;
  gap: 18px;
  flex-wrap: wrap;
  align-items: center;
}

.zuppa_lms_foot_pg_icon_link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  transition: transform 0.25s ease;
}

.zuppa_lms_foot_pg_icon_link:hover {
  transform: translateY(-4px);
}

.zuppa_lms_foot_pg_icon_img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 8px;
  background: rgba(0, 180, 255, 0.08);
  padding: 6px;
  border: 1px solid rgba(0, 180, 255, 0.2);
  transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
}

.zuppa_lms_foot_pg_icon_link:hover .zuppa_lms_foot_pg_icon_img {
  border-color: rgba(0, 180, 255, 0.7);
  box-shadow: 0 0 12px rgba(0, 180, 255, 0.35);
  background: rgba(0, 180, 255, 0.15);
}

.zuppa_lms_foot_pg_icon_label {
  font-size: 0.65rem;
  color: #7ab8d4;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 500;
}

/* ============================================
   ADDRESS SECTION (Right)
   ============================================ */
.zuppa_lms_foot_pg_address {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.zuppa_lms_foot_pg_address_title {
  font-family: 'Rajdhani', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #ff9100;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin: 0;
  position: relative;
  padding-bottom: 8px;
}

.zuppa_lms_foot_pg_address_title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 36px;
  height: 2px;
  background: linear-gradient(90deg, #ffa600, transparent);
  border-radius: 2px;
}

.zuppa_lms_foot_pg_address_body {
  font-style: normal;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.zuppa_lms_foot_pg_address_line {
  font-size: 0.85rem;
  color: #a8cde0;
  margin: 0;
  line-height: 1.6;
  font-weight: 400;
}

/* ============================================
   DECORATIVE GIF
   ============================================ */
.zuppa_lms_foot_pg_gif {
  width: 200px;
  height: auto;
  object-fit: contain;
  align-self: flex-end;
  border-radius: 12px;
  opacity: 0.88;
  transition: opacity 0.3s ease;
}

.zuppa_lms_foot_pg_gif:hover {
  opacity: 1;
}

/* ============================================
   COPYRIGHT BAR
   ============================================ */
.zuppa_lms_foot_pg_copyright {
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.35);
  border-top: 1px solid rgba(0, 180, 255, 0.12);
  padding: 14px 5%;
  text-align: center;
}

.zuppa_lms_foot_pg_copyright_text {
  font-size: 0.78rem;
  color: #4a7a99;
  margin: 0;
  letter-spacing: 0.06em;
  font-weight: 400;
}

/* ============================================
   RESPONSIVE — Large Desktop (≥1400px)
   ============================================ */
@media (min-width: 1400px) {
  .zuppa_lms_foot_pg_container {
    gap: 60px;
  }
  .zuppa_lms_foot_pg_brand_name {
    font-size: 1.25rem;
  }
}

/* ============================================
   RESPONSIVE — Tablet Landscape (≤1100px)
   ============================================ */
@media (max-width: 1100px) {
  .zuppa_lms_foot_pg_container {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    gap: 36px;
  }

  .zuppa_lms_foot_pg_brand {
    grid-column: 1;
    grid-row: 1;
  }

  .zuppa_lms_foot_pg_address {
    grid-column: 2;
    grid-row: 1;
  }

  .zuppa_lms_foot_pg_social {
    grid-column: 1;
    grid-row: 2;
  }

  .zuppa_lms_foot_pg_gif {
    grid-column: 2;
    grid-row: 2;
    justify-self: flex-end;
    align-self: center;
    width: 95px;
  }
}

/* ============================================
   RESPONSIVE — Tablet Portrait (≤768px)
   ============================================ */
@media (max-width: 768px) {
  .zuppa_lms_foot_pg_wrapper {
    padding: 44px 6% 32px;
  }

  .zuppa_lms_foot_pg_container {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }

  .zuppa_lms_foot_pg_gif {
    width: 80px;
  }

  .zuppa_lms_foot_pg_logo {
    width: 90px;
  }

  .zuppa_lms_foot_pg_brand_name {
    font-size: 1rem;
  }

  .zuppa_lms_foot_pg_icon_img {
    width: 32px;
    height: 32px;
  }

  .zuppa_lms_foot_pg_social_icons {
    gap: 14px;
  }
}

/* ============================================
   RESPONSIVE — Mobile Large (≤540px)
   ============================================ */
@media (max-width: 540px) {
  .zuppa_lms_foot_pg_wrapper {
    padding: 36px 5% 28px;
  }

  .zuppa_lms_foot_pg_container {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 28px;
    text-align: center;
  }

  .zuppa_lms_foot_pg_brand {
    grid-column: 1;
    grid-row: 1;
    align-items: center;
  }

  .zuppa_lms_foot_pg_social {
    grid-column: 1;
    grid-row: 2;
    align-items: center;
  }

  .zuppa_lms_foot_pg_social_title::after,
  .zuppa_lms_foot_pg_address_title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .zuppa_lms_foot_pg_address {
    grid-column: 1;
    grid-row: 3;
    align-items: center;
  }

  .zuppa_lms_foot_pg_address_body {
    align-items: center;
  }

  .zuppa_lms_foot_pg_gif {
    grid-column: 1;
    grid-row: 4;
    justify-self: center;
    align-self: center;
    width: 90px;
  }

  .zuppa_lms_foot_pg_social_icons {
    justify-content: center;
    gap: 16px;
  }

  .zuppa_lms_foot_pg_logo {
    width: 85px;
  }

  .zuppa_lms_foot_pg_brand_name {
    font-size: 0.95rem;
    text-align: center;
  }
}

/* ============================================
   RESPONSIVE — Mobile Small (≤380px)
   ============================================ */
@media (max-width: 380px) {
  .zuppa_lms_foot_pg_wrapper {
    padding: 28px 4% 24px;
  }

  .zuppa_lms_foot_pg_brand_name {
    font-size: 0.88rem;
  }

  .zuppa_lms_foot_pg_icon_img {
    width: 28px;
    height: 28px;
    padding: 5px;
  }

  .zuppa_lms_foot_pg_social_icons {
    gap: 12px;
  }

  .zuppa_lms_foot_pg_address_line {
    font-size: 0.8rem;
  }

  .zuppa_lms_foot_pg_copyright_text {
    font-size: 0.72rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAIjD,0BAA0B;AAC1B;EACE,WAAW;EACX,0EAA0E;EAC1E,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,yCAAyC;EACzC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,wCAAwC;EACxC,iFAAiF;AACnF;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD;EACE;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================\r\n   ZUPPA LMS FOOTER - Full Responsive CSS\r\n   All classNames prefixed: zuppa_lms_foot_pg_\r\n   ============================================ */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@400;500;600;700&family=Inter:wght@300;400;500&display=swap');\r\n\r\n/* ---- Root Footer ---- */\r\n.zuppa_lms_foot_pg_footer {\r\n  width: 100%;\r\n  background: linear-gradient(135deg, #0a0f1e 0%, #0d1b2a 50%, #0a1628 100%);\r\n  font-family: 'Inter', sans-serif;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* ---- Canvas Background ---- */\r\n.zuppa_lms_foot_pg_canvas {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  opacity: 0.15;\r\n  z-index: 0;\r\n}\r\n\r\n/* ---- Outer Wrapper ---- */\r\n.zuppa_lms_foot_pg_wrapper {\r\n  position: relative;\r\n  z-index: 1;\r\n  border-top: 2px solid rgb(255, 123, 0);\r\n  padding: 60px 5% 40px;\r\n}\r\n\r\n/* ---- Inner Grid Container ---- */\r\n.zuppa_lms_foot_pg_container {\r\n  display: grid;\r\n  grid-template-columns: 1.4fr 1fr 1fr auto;\r\n  gap: 40px;\r\n  align-items: start;\r\n  max-width: 1300px;\r\n  margin: 0 auto;\r\n  position: relative;\r\n}\r\n\r\n/* ============================================\r\n   BRAND SECTION (Left)\r\n   ============================================ */\r\n.zuppa_lms_foot_pg_brand {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_logo {\r\n  width: 80px;\r\n  height: auto;\r\n  object-fit: contain;\r\n  filter: drop-shadow(0 0 10px rgba(0, 180, 255, 0.4));\r\n  transition: filter 0.3s ease;\r\n}\r\n\r\n.zuppa_lms_foot_pg_logo:hover {\r\n  filter: drop-shadow(0 0 18px rgba(0, 220, 255, 0.7));\r\n}\r\n\r\n.zuppa_lms_foot_pg_brand_name {\r\n  font-family: 'Rajdhani', sans-serif;\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: #e0f4ff;\r\n  letter-spacing: 0.04em;\r\n  margin: 0;\r\n  line-height: 1.3;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.zuppa_lms_foot_pg_brand_sub {\r\n  font-size: 0.78rem;\r\n  color: #ff9900;\r\n  letter-spacing: 0.12em;\r\n  text-transform: uppercase;\r\n  margin: 0;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ============================================\r\n   SOCIAL SECTION (Center)\r\n   ============================================ */\r\n.zuppa_lms_foot_pg_social {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 18px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_social_title {\r\n  font-family: 'Rajdhani', sans-serif;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #ff7300;\r\n  letter-spacing: 0.15em;\r\n  text-transform: uppercase;\r\n  margin: 0;\r\n  position: relative;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_social_title::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 36px;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, #ff7300, transparent);\r\n  border-radius: 2px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_social_icons {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 18px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.zuppa_lms_foot_pg_icon_link {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 6px;\r\n  text-decoration: none;\r\n  transition: transform 0.25s ease;\r\n}\r\n\r\n.zuppa_lms_foot_pg_icon_link:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.zuppa_lms_foot_pg_icon_img {\r\n  width: 36px;\r\n  height: 36px;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n  background: rgba(0, 180, 255, 0.08);\r\n  padding: 6px;\r\n  border: 1px solid rgba(0, 180, 255, 0.2);\r\n  transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;\r\n}\r\n\r\n.zuppa_lms_foot_pg_icon_link:hover .zuppa_lms_foot_pg_icon_img {\r\n  border-color: rgba(0, 180, 255, 0.7);\r\n  box-shadow: 0 0 12px rgba(0, 180, 255, 0.35);\r\n  background: rgba(0, 180, 255, 0.15);\r\n}\r\n\r\n.zuppa_lms_foot_pg_icon_label {\r\n  font-size: 0.65rem;\r\n  color: #7ab8d4;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n}\r\n\r\n/* ============================================\r\n   ADDRESS SECTION (Right)\r\n   ============================================ */\r\n.zuppa_lms_foot_pg_address {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_address_title {\r\n  font-family: 'Rajdhani', sans-serif;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #ff9100;\r\n  letter-spacing: 0.15em;\r\n  text-transform: uppercase;\r\n  margin: 0;\r\n  position: relative;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_address_title::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 36px;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, #ffa600, transparent);\r\n  border-radius: 2px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_address_body {\r\n  font-style: normal;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.zuppa_lms_foot_pg_address_line {\r\n  font-size: 0.85rem;\r\n  color: #a8cde0;\r\n  margin: 0;\r\n  line-height: 1.6;\r\n  font-weight: 400;\r\n}\r\n\r\n/* ============================================\r\n   DECORATIVE GIF\r\n   ============================================ */\r\n.zuppa_lms_foot_pg_gif {\r\n  width: 200px;\r\n  height: auto;\r\n  object-fit: contain;\r\n  align-self: flex-end;\r\n  border-radius: 12px;\r\n  opacity: 0.88;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.zuppa_lms_foot_pg_gif:hover {\r\n  opacity: 1;\r\n}\r\n\r\n/* ============================================\r\n   COPYRIGHT BAR\r\n   ============================================ */\r\n.zuppa_lms_foot_pg_copyright {\r\n  position: relative;\r\n  z-index: 1;\r\n  background: rgba(0, 0, 0, 0.35);\r\n  border-top: 1px solid rgba(0, 180, 255, 0.12);\r\n  padding: 14px 5%;\r\n  text-align: center;\r\n}\r\n\r\n.zuppa_lms_foot_pg_copyright_text {\r\n  font-size: 0.78rem;\r\n  color: #4a7a99;\r\n  margin: 0;\r\n  letter-spacing: 0.06em;\r\n  font-weight: 400;\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE — Large Desktop (≥1400px)\r\n   ============================================ */\r\n@media (min-width: 1400px) {\r\n  .zuppa_lms_foot_pg_container {\r\n    gap: 60px;\r\n  }\r\n  .zuppa_lms_foot_pg_brand_name {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE — Tablet Landscape (≤1100px)\r\n   ============================================ */\r\n@media (max-width: 1100px) {\r\n  .zuppa_lms_foot_pg_container {\r\n    grid-template-columns: 1fr 1fr;\r\n    grid-template-rows: auto auto;\r\n    gap: 36px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_brand {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_address {\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social {\r\n    grid-column: 1;\r\n    grid-row: 2;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_gif {\r\n    grid-column: 2;\r\n    grid-row: 2;\r\n    justify-self: flex-end;\r\n    align-self: center;\r\n    width: 95px;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE — Tablet Portrait (≤768px)\r\n   ============================================ */\r\n@media (max-width: 768px) {\r\n  .zuppa_lms_foot_pg_wrapper {\r\n    padding: 44px 6% 32px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_container {\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 28px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_gif {\r\n    width: 80px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_logo {\r\n    width: 90px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_brand_name {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_icon_img {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social_icons {\r\n    gap: 14px;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE — Mobile Large (≤540px)\r\n   ============================================ */\r\n@media (max-width: 540px) {\r\n  .zuppa_lms_foot_pg_wrapper {\r\n    padding: 36px 5% 28px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_container {\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: auto;\r\n    gap: 28px;\r\n    text-align: center;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_brand {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    align-items: center;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social {\r\n    grid-column: 1;\r\n    grid-row: 2;\r\n    align-items: center;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social_title::after,\r\n  .zuppa_lms_foot_pg_address_title::after {\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_address {\r\n    grid-column: 1;\r\n    grid-row: 3;\r\n    align-items: center;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_address_body {\r\n    align-items: center;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_gif {\r\n    grid-column: 1;\r\n    grid-row: 4;\r\n    justify-self: center;\r\n    align-self: center;\r\n    width: 90px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social_icons {\r\n    justify-content: center;\r\n    gap: 16px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_logo {\r\n    width: 85px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_brand_name {\r\n    font-size: 0.95rem;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n/* ============================================\r\n   RESPONSIVE — Mobile Small (≤380px)\r\n   ============================================ */\r\n@media (max-width: 380px) {\r\n  .zuppa_lms_foot_pg_wrapper {\r\n    padding: 28px 4% 24px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_brand_name {\r\n    font-size: 0.88rem;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_icon_img {\r\n    width: 28px;\r\n    height: 28px;\r\n    padding: 5px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_social_icons {\r\n    gap: 12px;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_address_line {\r\n    font-size: 0.8rem;\r\n  }\r\n\r\n  .zuppa_lms_foot_pg_copyright_text {\r\n    font-size: 0.72rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
